import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Sparkles, Pencil, User, ShieldCheck } from "lucide-react";

const VARIANTS = {
  ai:             { label: "AI",        cls: "bg-sky-100 text-sky-700 border-sky-200",       icon: Sparkles, tip: "Value suggested by the AI extractor." },
  ai_corrected:   { label: "Corrected", cls: "bg-amber-100 text-amber-800 border-amber-200", icon: Pencil,   tip: "AI value was edited by the user." },
  manual:         { label: "Manual",    cls: "bg-slate-100 text-slate-700 border-slate-200", icon: User,     tip: "Entered by hand." },
  salihi_reviewed:{ label: "Reviewed",  cls: "bg-emerald-100 text-emerald-700 border-emerald-200", icon: ShieldCheck, tip: "Salihi has reviewed and verified this field." },
};

export function OriginBadge({ origin, testid }) {
  const v = VARIANTS[origin] || VARIANTS.manual;
  const Icon = v.icon;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className={`${v.cls} font-medium inline-flex items-center gap-1 px-2 py-0`}
            data-testid={testid}
          >
            <Icon className="h-3 w-3" />
            {v.label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>{v.tip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default OriginBadge;
